<template>
  <div
    :class="{
      'contact-detail-fi': true,
      'contact-detail-fi--link': href,
    }"
  >
    <icon-fi
      v-if="icon"
      class="contact-detail-fi__icon"
      :icon="icon"
    />

    <component
      :is="href ? 'a' : 'span'"
      :class="`contact-detail-fi__text fi-text-size-df-${dfTextSize}`"
      :href="href"
      :target="target"
      :rel="target && target === '_blank' ? 'noopener noreferrer' : null"
    >
      {{ detail }}
    </component>
  </div>
</template>

<script>
import { IconFi } from 'atoms';

export default {
  name: 'ContactDetails',
  components: {
    IconFi,
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: null,
    },
    target: {
      type: String,
      required: false,
      default: null,
    },
    href: {
      type: String,
      required: false,
      default: null,
    },
    detail: {
      type: String,
      required: true,
    },
    dfTextSize: {
      type: Number,
      default: 16,
    },
  },
};
</script>

<style scoped lang="scss">
@import './contact-detail-fi';
</style>
